module.exports = __webpack_public_path__ + "images/cm-hero-bg1-mobile.png";